import { GetLeadByExternalId200 } from '../../../../../../services/marketplace/generated/kubb/models/GetLeadByExternalId';
import { LeadDetailStatusEnumKey } from '../../../../../../services/marketplace/generated/kubb/models/LeadDetail';
import { LISTING_STATUS_MAP } from '../../listingStatus';

const TERMINAL_STATUS: LeadDetailStatusEnumKey = 'sold';

export const isOffRampStatus = (status?: LeadDetailStatusEnumKey | null): boolean =>
  status != null && LISTING_STATUS_MAP[status] === 'ended';

const isPostAcceptanceActiveStatus = (status: LeadDetailStatusEnumKey): boolean => {
  const listing = LISTING_STATUS_MAP[status];
  return listing === 'accepted' || listing === 'sold';
};

export const isLivePostAcceptanceStatus = (status?: LeadDetailStatusEnumKey | null): boolean =>
  status != null && status !== TERMINAL_STATUS && isPostAcceptanceActiveStatus(status);

// A never-accepted expired listing keeps the normal ended view.
export const isPostAcceptanceLead = (lead?: GetLeadByExternalId200 | null): boolean => {
  if (!lead) return false;
  if (isPostAcceptanceActiveStatus(lead.status)) return true;
  return isOffRampStatus(lead.status) && lead.acceptedAt != null;
};
